import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Stack,
  Button,
  Typography,
  Divider,
  CircularProgress,
  Alert,
  MenuItem,
  Select,
} from "@mui/material";
import { styled } from "@mui/material";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import DataTable from "../../DataTable/index";
import CALC_ICON from "../../../assets/images/calc.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "react-circular-progressbar/dist/styles.css";
import AddScoreCardModal from "../AddScoreCard";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ProfileInfo from "../ProfileInfo";
import ScoreDetailsModal from "../ScoreDetails";
import clsx from "clsx";
import "./playerProfile.css";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet, apiPost } from "../../../utils/apiRequests";
import { getMinimalPlayers } from "../../../redux/actions/player-area-action/scores-action";

import jwtDecode from "jwt-decode";

const BEST_SCORE_IMG = require("../../../assets/images/best-round-selection.png");

const useStyles = makeStyles((theme) => ({
  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    borderRadius: "5px !important",
    fontWeight: "400 !important",
    minWidth: "175px !important",
    padding: "10px 20px !important",
    textTransform: "capitalize !important",
  },
  profileHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
    position: "relative",
  },
  profileImg: {
    width: "30%",
    border: "4px solid #FFF",
    borderRadius: 100,
    position: "absolute",
    top: 65,
    marginBottom: 100,
  },
  profileHeaderText: {
    backgroundColor: "#06623B !important",
    color: "#fff",
    width: "100%",
    padding: "7% 3% 15%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  socialBtn: {
    cursor: "pointer",
    backgroundColor: "#000000",
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  profileStatText: {
    backgroundColor: "#06623B",
    color: "#fff",
    width: "100%",
    textAlign: "center",
    margin: "20px 0 !important",
    padding: "10px",
  },
  scoreIcon: {
    width: 30,
    height: 30,
    marginRight: 15,
  },
  divider: {
    width: "2% !important",
    height: "100% !important",
  },
  bestRoundClass: {
    boxShadow: "-2px -2px -2px -2px red",
    clipPath: "circle(70%)",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  p: 4,
};

const customStyles = {
  headRow: {
    style: {
      minHeight: "35px",
      maxHeight: "35px",
      borderBottomStyle: "none",
    },
  },
  headCells: {
    style: {
      minWidth: "37px !important",
      padding: 0,
      margin: 0,
      backgroundColor: "#06623B",
      color: "#FFF",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  rows: {
    style: {
      minHeight: "35px",
      maxHeight: "35px",
      "&:last-child": {
        marginBottom: "10px",
      },
    },
  },
  cells: {
    style: {
      minWidth: "37px !important",
      padding: 0,
      margin: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&:nth-child(odd)": {
        backgroundColor: "#D9D9D9",
        border: "1px solid #000000",
      },
      "&:nth-child(even)": {
        borderTop: "1px solid #000000",
        borderBottom: "1px solid #000000",
      },
      "&:last-child": {
        borderRight: "1px solid #000000",
      },
    },
  },
};

const wordNumbers = [
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
];

const StyledLeagueSelector = styled(Select)(() => ({
  maxWidth: "280px",
  width: "280px",
  border: "1.47px solid #C4C4C4 !important",
  borderRadius: "8px",
  margin: "3px 0px",
  padding: "6px 5px",
  fontSize: "14px !important",
  fontWeight: "700 !important",
  "::before": { display: "none" },
  ["@media (max-width: 568px)"]: {
    width: "100%",
  },
}));

export default function PlayerProfile() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const userId = params?.id;

  const location = useLocation();

  const userInfo = useSelector((state) => state?.userDetailsReducer?.data);
  const { role } = useSelector((state) => state.userDetailsReducer);
  const getMinimalPlayer = useSelector(
    (state) => state?.getMinimalPlayerReducer.data
  );

  const [playerData, setPlayerData] = useState(null);

  const token = localStorage.getItem("token");
  const [playerScoresDetails, setPlayerScoresDetails] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("An Error Occurred...");
  const [isError, setIsError] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("Text in a modal");
  const [modalText, setModalText] = useState(
    "Duis mollis, est non commodo luctus, nisi erat porttitor ligula."
  );
  const [showImage, setShowImage] = useState(false);
  const [showScoreIcon, setShowScoreIcon] = useState(false);
  const [openScoreDetailsModal, setOpenScoreDetailsModal] = useState(false);
  const [openAddScoreModal, setOpenAddScoreModal] = useState(false);
  const [gross_adjusted_scores_data, setGASData] = useState([]);
  const [adjusted_scores_data, setASData] = useState([]);
  const [playerHandicapDiff, setPlayerHandicapDiff] = useState([]);
  const [bestRoundSelectionIndex, setBestRoundSelectionIndex] = useState([]);
  const [whsIndex, setWHSIndex] = useState("");
  const [storeCard, setScoreCard] = useState({});
  const [selectedPlayer, setSelectedPlayer] = useState(userId);
  const [averageScore, setAverageScore] = useState(0);

  const getPlayerDetails = () => {
    apiGet(`${ApiEndpoints.user.basicInfo}${selectedPlayer}`, (res) => {
      if (!res.error) {
        setPlayerData(res.data);
      }
    });
  };

  const handleClickPlayerAccount = () => {
    if (location.state.isFromDashboard) {
      navigate("/playerAccount/" + decodedToken?.id, {
        replace: false,
        state: { playerData, isFromDashboard: true, averageScore },
      });
    } else {
      navigate("/playerAccount/" + userId, {
        replace: false,
        state: { playerData, averageScore },
      });
    }
  };

  const handleScoreDetailsModalOpen = (data) => {
    if (data.match_type) {
      let body = {
        type: data.match_type,
        user_id: data.user_id,
        ...(data.match_type === "DMP" || data.match_type === "SMP"
          ? {
            match_id: data.match_id,
            course_id: data.course_id,
            round_id: data.round_id,
          }
          : {
            tournament_id: data.tournament_id,
            draw_id: data.draw_id,
          }),
      };

      apiPost(
        "/api/players/scorecard-details",
        body,
        (response) => {
          if (response.error) {
            setScoreCard({});
          } else {
            setScoreCard(response.data);
          }
        },
        (error) => {
          console.log("error ===>>>>", error);
        }
      );
    } else {
      setScoreCard({ score: data.score });
    }

    setOpenScoreDetailsModal(true);
  };

  const handleScoreDetailsModalClose = () => {
    setOpenScoreDetailsModal(false);
  };

  const handleAddScoreModalOpen = () => {
    setOpenAddScoreModal(true);
  };

  const handleAddScoreModalClose = () => {
    setOpenAddScoreModal(false);
  };

  const handleClose = () => {
    setShowImage(false);
    setShowScoreIcon(false);
    setOpen(false);
  };

  const GrossScoreColumn = () => {
    let columns = [];
    wordNumbers.map((column, index) => {
      columns.push({
        name: index + 1 + "",
        selector: (row) => row[index],
        cell: (row) => (
          <Typography onClick={() => handleScoreDetailsModalOpen(row[index])}>
            {row[index]?.score}
          </Typography>
        ),
        width: "52px",
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      });
    });
    return columns;
  };

  const GrossAdjustedScoreColumns = () => {
    let columns = [];
    wordNumbers.map((column, index) => {
      columns.push({
        name: index + 1 + "",
        selector: (row) => row[index],
        cell: (row) => (
          <Typography onClick={() => handleScoreDetailsModalOpen(row[index])}>
            {row[index]?.adjusted_score}
          </Typography>
        ),
        width: "52px",
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      });
    });
    return columns;
  };

  const HandicapColumns = () => {
    let columns = [];
    wordNumbers.map((column, index) => {
      columns.push({
        name: index + 1 + "",
        selector: (row) => row[index],
        // selector: row => row.index,
        // selector: (row, index) => row[index + 1 ],
        cell: (row) => row[index],
        width: "52px",
      });
    });
    return columns;
  };

  const findBRSIndex = (index) => {
    let filter = bestRoundSelectionIndex[0]?.includes(index);

    return filter;
  };

  const BestRoundSelection = () => {
    let columns = [];

    wordNumbers.map((wordNumber, wnindex) => {
      columns.push({
        name: wnindex + 1 + "",
        selector: (row, index) => (
          <span
            className={clsx({ "best-round-circle": findBRSIndex(wnindex) })}
          >
            <span>{row[wnindex]}</span>
          </span>
        ),
        width: "52px",
      });
    });
    return columns;
  };

  const handlePlayerId = (e) => {
    const { value } = e.target;
    setSelectedPlayer(value);
  };

  useEffect(() => {
    apiGet(
      `${ApiEndpoints.profile.details}${selectedPlayer}`,
      (res) => {
        let total = res?.Data?.gross_adjusted_scores.reduce(
          (total, num) => total + num
        );

        total = total / res?.Data?.gross_adjusted_scores.length;

        setAverageScore(total);

        setIsLoading(false);
        setPlayerScoresDetails(res.Data);
        console.log(res.Data);
        setGASData([res.Data?.gross_score_array]);
        setASData([res.Data?.gross_score_array]);
        setPlayerHandicapDiff([res.Data?.handicap_diff]);
        setWHSIndex(res.Data?.whs_index_calculation);
        setBestRoundSelectionIndex([res.Data?.best_round_selection_indexes]);
      },
      (err) => {
        setErrorMessage("Error: " + err.message);
        setIsError(true);
        setIsLoading(false);
      }
    );
    getPlayerDetails();
  }, [role, selectedPlayer]);

  useEffect(() => {
    dispatch(getMinimalPlayers(role));
  }, []);

  useEffect(() => {
    if (getMinimalPlayer !== undefined && getMinimalPlayer.length > 0) {
      setSelectedPlayer(userId);
    }
  }, [getMinimalPlayer]);

  const gross_score_columns = GrossScoreColumn();
  const gross_adjusted_score_columns = GrossAdjustedScoreColumns();
  const handicap_differential_columns = HandicapColumns();
  const best_round_selection_columns = BestRoundSelection();

  const RenderModal = () => {
    return (
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {showScoreIcon ? (
                <img
                  src={CALC_ICON}
                  alt="calculation"
                  className={classes.scoreIcon}
                />
              ) : (
                <InfoOutlinedIcon sx={{ mr: 1 }} />
              )}
              <Typography id="modal-modal-title" variant="h6">
                {modalTitle}
              </Typography>
            </Box>
            <CancelOutlinedIcon
              sx={{ cursor: "pointer" }}
              onClick={handleClose}
            />
          </Box>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, mb: 2, textAlign: "center" }}
          >
            {modalText}
          </Typography>

          {showImage && (
            <img src={BEST_SCORE_IMG} alt="best score" width={"100%"} />
          )}
        </Box>
      </Modal>
    );
  };

  const decodedToken = jwtDecode(token);

  return (
    <Grid container p={3}>
      <Grid item xs={12}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <StyledLeagueSelector
            fullWidth
            value={selectedPlayer}
            disableUnderline
            variant="standard"
            onChange={handlePlayerId}
          >
            {getMinimalPlayer !== undefined &&
              getMinimalPlayer.map((val, index) => (
                <MenuItem value={val._id} key={index}>
                  {val.first_name} {val.last_name}
                </MenuItem>
              ))}
          </StyledLeagueSelector>
          {role !== "player" ? (
            <Button
              className={classes.playerprofilebtn}
              onClick={handleClickPlayerAccount}
            >
              Account Settings
            </Button>
          ) : (
            userInfo._id === userId &&
            selectedPlayer === userId && (
              <Button
                className={classes.playerprofilebtn}
                onClick={handleClickPlayerAccount}
              >
                Account Settings
              </Button>
            )
          )}
        </Stack>
      </Grid>

      <Grid item xs={12}>
        {isError ? (
          <Alert severity="error" sx={{ marginTop: 2 }}>
            {errorMessage}
          </Alert>
        ) : null}

        <Grid container py={3}>
          <Grid item xs={12} lg={3}>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <CircularProgress color="success" />
                <Typography mt={1}>Loading...</Typography>
              </Box>
            ) : isError ? null : (
              <ProfileInfo playerData={playerData} average={averageScore} />
            )}
          </Grid>

          <Grid
            item
            xs={1}
            display={{ xs: "none", lg: "flex" }}
            justifyContent="center"
          >
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>

          <Grid item xs={12} lg={8}>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <CircularProgress color="success" />
                <Typography mt={1}>Loading...</Typography>
              </Box>
            ) : isError ? null : (
              <>
                <Typography variant="h6" sx={{ fontWeight: "600", pb: "2px" }}>
                  Handicap Calculator
                </Typography>
                <Divider
                  orientation="horizontal"
                  sx={{ height: "3px !important", marginBottom: "5px" }}
                />
                <Grid container>
                  <Grid item xs={12} mb={2}>
                    <Typography variant="subtitle1" fontWeight={600} mb={1}>
                      Gross Scores
                    </Typography>
                    <DataTable
                      columns={gross_score_columns}
                      data={adjusted_scores_data}
                      customStyles={customStyles}
                    />
                  </Grid>
                  <Grid item xs={12} mb={2}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <Typography variant="subtitle1" fontWeight={"600"}>
                        Gross Adjusted Scores
                      </Typography>
                      <InfoOutlinedIcon
                        onClick={() => {
                          setModalTitle("Gross Adjusted Scores");
                          setModalText(
                            "Method: To arrive at an Adjusted Gross Score, you use the WHS's Equitable Stroke Control (ESC). ESC is used to downwardly adjust individual hole scores for handicapping purposes in order to create handicaps that better represent a golfer's playing ability. ESC imposes a maximum number of strokes that can be entered for any given hole. This is a DOUBLE BOGEY."
                          );
                          setOpen(true);
                        }}
                        fontSize="small"
                        sx={{ ml: 0.8, cursor: "pointer" }}
                      />
                    </Box>

                    <DataTable
                      columns={gross_adjusted_score_columns}
                      data={gross_adjusted_scores_data}
                      customStyles={customStyles}
                    />
                  </Grid>
                  <Grid item xs={12} mb={2}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <Typography variant="subtitle1" fontWeight={"600"}>
                        Handicap Differential
                      </Typography>
                      <InfoOutlinedIcon
                        onClick={() => {
                          setModalTitle("Handicap Differential");
                          setModalText(
                            `The second step in computing a Handicap Index is to compute a Handicap Differential for each score that is to be considered in the Handicap Index calculation. The Handicap Differential is computed using the following formula: Handicap Differential = (Adjusted Gross Score - Course Rating) X 113 ÷ Slope Rating (The Course Rating is what the WHS deems a scratch golfer would score on a course under normal playing conditions. A Slope Rating of 113 is for a course of standard difficulty according to the WHS.`
                          );
                          setOpen(true);
                        }}
                        fontSize="small"
                        sx={{ ml: 0.8, cursor: "pointer" }}
                      />
                    </Box>

                    <DataTable
                      columns={handicap_differential_columns}
                      data={playerHandicapDiff}
                      customStyles={customStyles}
                    />
                  </Grid>
                  <Grid item xs={12} mb={2}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <Typography variant="subtitle1" fontWeight={"600"}>
                        Best Round Selection
                      </Typography>
                      <InfoOutlinedIcon
                        onClick={() => {
                          setModalTitle("Best Round Selection");
                          setModalText(
                            "The third step in calculating your Handicap Index is to select the lowest Handicap Differentials. The following table is used when selecting the best, or lowest, Handicap Differentials. If more than 20 scores have been entered, the 8 best differentials of the 20 most recent scores are used for the calculation."
                          );
                          setShowImage(true);
                          setOpen(true);
                        }}
                        fontSize="small"
                        sx={{ ml: 0.8, cursor: "pointer" }}
                      />
                    </Box>
                    <DataTable
                      columns={best_round_selection_columns}
                      data={playerHandicapDiff || []}
                      customStyles={customStyles}
                    />
                  </Grid>
                  <Grid item xs={12} mb={2}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      WHS Index
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={"400"}>
                      {whsIndex}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} mb={2}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Playing Handicap
                      </Typography>
                      <InfoOutlinedIcon
                        onClick={() => {
                          setModalTitle("Playing Handicap");
                          setModalText(
                            "Playing Handicap = ((Handicap Index x Slope Rating)/113 + (Course Rating - Course Par) x 95% Rounded to nearest whole number."
                          );
                          setOpen(true);
                        }}
                        fontSize="small"
                        sx={{ ml: 0.8, cursor: "pointer" }}
                      />
                    </Box>

                    <Grid container>
                      <Grid
                        item
                        margin={2}
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"flex-start"}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#0000FF",
                            width: 25,
                            height: 25,
                            borderRadius: "25%",
                            padding: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1.2,
                          }}
                        >
                          <Typography fontWeight={"700"} color={"#FFF"}>
                            {playerScoresDetails?.blue_tee}
                          </Typography>
                        </Box>
                        <sup>
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              setModalTitle("Blue Tee Playing Handicap");
                              setModalText(
                                playerScoresDetails?.blue_tee_calculation
                              );
                              setShowScoreIcon(true);
                              setOpen(true);
                            }}
                          >
                            <img src={CALC_ICON} alt="calculation" width={20} />
                          </Box>
                        </sup>
                      </Grid>
                      <Grid
                        item
                        margin={2}
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"flex-start"}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#DED8D0",
                            width: 25,
                            height: 25,
                            borderRadius: "25%",
                            padding: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1.2,
                          }}
                        >
                          <Typography fontWeight={"700"} color={"#FFF"}>
                            {playerScoresDetails?.white_tee}
                          </Typography>
                        </Box>
                        <sup>
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              setModalTitle("White Tee Playing Handicap");
                              setModalText(
                                playerScoresDetails?.white_tee_calculation
                              );
                              setShowScoreIcon(true);
                              setOpen(true);
                            }}
                          >
                            <img src={CALC_ICON} alt="calculation" width={20} />
                          </Box>
                        </sup>
                      </Grid>
                      <Grid
                        item
                        margin={2}
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"flex-start"}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#EE920F",
                            width: 25,
                            height: 25,
                            borderRadius: "25%",
                            padding: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1.2,
                          }}
                        >
                          <Typography fontWeight={"700"} color={"#FFF"}>
                            {playerScoresDetails?.yellow_tee}
                          </Typography>
                        </Box>
                        <sup>
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              setModalTitle("Yellow Tee Playing Handicap");
                              setModalText(
                                playerScoresDetails?.yellow_tee_calculation
                              );
                              setShowScoreIcon(true);
                              setOpen(true);
                            }}
                          >
                            <img src={CALC_ICON} alt="calculation" width={20} />
                          </Box>
                        </sup>
                      </Grid>
                      <Grid
                        item
                        margin={2}
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"flex-start"}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#000000",
                            width: 25,
                            height: 25,
                            borderRadius: "25%",
                            padding: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 1.2,
                          }}
                        >
                          <Typography fontWeight={"700"} color={"#FFF"}>
                            {playerScoresDetails?.black_tee}
                          </Typography>
                        </Box>
                        <sup>
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              setModalTitle("Black Tee Playing Handicap");
                              setModalText(
                                playerScoresDetails?.black_tee_calculation
                              );
                              setShowScoreIcon(true);
                              setOpen(true);
                            }}
                          >
                            <img src={CALC_ICON} alt="calculation" width={20} />
                          </Box>
                        </sup>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      {RenderModal()}
      {openScoreDetailsModal ? (
        <ScoreDetailsModal
          score={storeCard}
          setScore={setScoreCard}
          handleOpenModal={handleScoreDetailsModalOpen}
          handleCloseModal={handleScoreDetailsModalClose}
        />
      ) : (
        <></>
      )}

      {openAddScoreModal ? (
        <AddScoreCardModal
          handleOpenModal={handleAddScoreModalOpen}
          handleCloseModal={handleAddScoreModalClose}
        />
      ) : (
        <></>
      )}
    </Grid>
  );
}
